/**
 * Store en memoria del access token JWT.
 *
 * NO se persiste en localStorage para evitar XSS-leak. El refresh token vive
 * en cookie httpOnly (no accesible desde JS), y el access se obtiene mediante
 * `POST /auth/refresh` cada vez que recargamos la app.
 *
 * Suscripción reactiva para que `useAuth` re-renderice cuando el token cambia.
 */
type Listener = (token: string | null) => void;

let currentToken: string | null = null;
const listeners = new Set<Listener>();

export const tokenStore = {
  get(): string | null {
    return currentToken;
  },
  set(token: string | null): void {
    if (currentToken === token) return;
    currentToken = token;
    listeners.forEach((l) => {
      l(token);
    });
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  reset(): void {
    currentToken = null;
    listeners.clear();
  },
};
